module.exports = __webpack_public_path__ + "media/admin/components/activities/live/agenda/item-types/election/vote-icon/n-5f37d3b512908b5e2e61a79f3dfee9da.png";